var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "grm-loading" }, [
    _c("div", { staticClass: "loading-container" }, [
      _c("img", {
        staticClass: "loading-image",
        attrs: {
          src: require("@/assets/images/camstudy/loading_gooroomee_change_type.png"),
          alt: "Loading",
        },
      }),
      _c("div", {
        staticClass: "loading-message",
        domProps: { innerHTML: _vm._s(_vm.message) },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }